import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { FAQS } from './salesData';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="bg-blush py-16 sm:py-24" data-id="element-92" data-mp="1gj3n5vfl39r0">
      <div className="mx-auto max-w-3xl px-5" data-id="element-93" data-mp="1glpwo0m1bzbv">
        <div className="text-center" data-id="element-94" data-mp="248xyu9o62s9o">
          <SectionTag data-id="element-95" data-mp="249zk16ywcv54">❓ Preguntas frecuentes</SectionTag>
          <h2 className="mt-4 font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-96" data-mp="28b1dt8a1oezp">
            Lo que más nos preguntan
          </h2>
        </div>

        <div className="mt-10 space-y-3" data-id="element-97" data-mp="1uhaa4gizvpbw">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={i} className="overflow-hidden rounded-2xl border border-rose/10 bg-white shadow-sm" data-id="element-98" data-mp="2n7ipy1q25xnb" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-99" data-mp="2rztyfsyv6rrh">
                  <span className="font-display text-base font-bold text-ink" data-id="element-100" data-mp="1elvhg56qj1us">{faq.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-rose transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-101" data-mp="19tc3v881s6pz" />
                </button>
                <AnimatePresence initial={false} data-id="element-102" data-mp="1jkznimyd4jgw">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeInOut'
              }} data-id="element-103" data-mp="1xkhjbma2swzr">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-ink/70" data-id="element-104" data-mp="3ucrewep16ci1">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}